var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserInviteIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    color: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5002 9.99996C12.8013 9.99996 14.6668 8.13448 14.6668 5.83329C14.6668 3.53211 12.8013 1.66663 10.5002 1.66663C8.19898 1.66663 6.3335 3.53211 6.3335 5.83329C6.3335 8.13448 8.19898 9.99996 10.5002 9.99996Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.3418 18.3333C3.3418 15.1083 6.55013 12.5 10.5001 12.5C11.3001 12.5 12.0751 12.6083 12.8001 12.8083",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8332 15C18.8332 15.2666 18.7998 15.525 18.7332 15.775C18.6582 16.1083 18.5248 16.4333 18.3498 16.7166C17.7748 17.6833 16.7165 18.3333 15.4998 18.3333C14.6415 18.3333 13.8665 18.0083 13.2832 17.4749C13.0332 17.2583 12.8165 17 12.6498 16.7166C12.3415 16.2166 12.1665 15.625 12.1665 15C12.1665 14.1 12.5248 13.275 13.1082 12.675C13.7165 12.05 14.5665 11.6666 15.4998 11.6666C16.4832 11.6666 17.3748 12.0916 17.9748 12.775C18.5082 13.3666 18.8332 14.15 18.8332 15Z",
    stroke: "#35D6AF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7416 14.9834H14.2583",
    stroke: "#35D6AF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 13.7668V16.2585",
    stroke: "#35D6AF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserInviteIcon);
export default __webpack_public_path__ + "static/media/user-invite-icon.907859a60af344be2b7279e9e4376238.svg";
export { ForwardRef as ReactComponent };